module.exports = __webpack_public_path__ + "static/img/li9_1.5bb08aa2.png";